import { render, staticRenderFns } from "./HistorialEstado.vue?vue&type=template&id=beabe106&scoped=true&"
import script from "./HistorialEstado.vue?vue&type=script&lang=js&"
export * from "./HistorialEstado.vue?vue&type=script&lang=js&"
import style0 from "./HistorialEstado.vue?vue&type=style&index=0&id=beabe106&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "beabe106",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VCard,VSpacer,VToolbar,VToolbarTitle})
